<script lang="ts">
  import { subDays } from "date-fns";
  import { getAppContext } from "./AppContext";
  import Chart from "chart.js";

  import { SubPage } from "@cohesionib/biblioteca/lib/TabPage";
  import { TabList } from "@cohesionib/biblioteca/lib/TabList";
  import OccupancyCurrent from "./occupancy/OccupancyCurrent.svelte";
  import ServiceRequests from "./serviceRequests/ServiceRequests.svelte";
  import AmenityReservations from "./amenityReservations";

  export let authToken: string;
  export let themeFont: string;
  export let themeAccentColor: string;
  export let buildingCode: string;

  Chart.defaults.global.defaultFontFamily = `${themeFont}, sans-serif`;
  const { feGatewaySdk, buildingCodeDemoList } = getAppContext();

  const occupancyCurrentPromise = feGatewaySdk.getOccupancyCurrent({
    buildingCode: buildingCodeDemoList.includes(buildingCode.toLowerCase()) ? "wwsf1" : buildingCode.toLowerCase(),
    endOfPreviousDay: new Date(),
    fromDate: subDays(new Date(), 1),
    toDate: new Date(),
  });
</script>

<style>

</style>

<div style={`--theme-font: ${themeFont};`}>
  {#await occupancyCurrentPromise}
    loading...
  {:then data}
    {#if data.building}
      <div style="font-family: var(--theme-font), sans-serif; font-size: 16px;">
        <TabList startOn="occupancy">
          <SubPage id="occupancy" title="Occupancy">
            <OccupancyCurrent occupancyCurrent={data} />
          </SubPage>
          {#if buildingCodeDemoList.includes(buildingCode.toLowerCase())}
            <SubPage id="service-requests" title="Service Requests">
              <ServiceRequests />
            </SubPage>
            <SubPage id="amenity-reservations" title="Amenities">
              <AmenityReservations />
            </SubPage>
          {/if}
        </TabList>
      </div>
    {:else}
      <div>No building data found</div>
    {/if}
  {:catch error}
    {console.error(error)}something went wrong, please try again later
  {/await}
</div>
